import { render } from "./RedTeamWidget.vue?vue&type=template&id=15fdd706"
import script from "./RedTeamWidget.vue?vue&type=script&lang=js"
export * from "./RedTeamWidget.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__